<template>
  <div class="GoodsItem" @click="tapEvent">
    <van-image
      fit="cover"
      class="pic"
      :src="goodsInfo.ProductHeadUrl"
      error-icon="photo"
    />
    <div class="bottomPart">
      <div class="title twoRow" v-text="goodsInfo.ProductName"></div>

      <div class="subBottom">
        <div class="tagBox">
          <div class="history" v-if="goodsInfo.ProductPrice">
            ￥{{ goodsInfo.ProductPrice }}
          </div>
          <div class="coupon" v-if="goodsInfo.CouponAmount">
            券{{ goodsInfo.CouponAmount | filterCoupon }}元
          </div>
        </div>
        <div class="priceBox" v-if="goodsInfo.RealAmount">
          <i class="symbol">￥</i>
          <span class="price" v-text="goodsInfo.RealAmount"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Image as VanImage } from "vant";
import { mapMutations } from "vuex";
export default {
  name: "GoodsItem",
  components: {
    VanImage,
  },
  props: {
    goodsInfo: {
      type: Object,
      default: () => {
        return {
          ProductHeadUrl: "",
          ProductName: "",
          ProductPrice: "",
          CouponAmount: "",
          RealAmount: "",
        };
      },
      required: false,
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    ...mapMutations(["SET_GOODS_DETAIL_DATA"]),
    tapEvent() {
      this.SET_GOODS_DETAIL_DATA(this.goodsInfo);
      this.$emit("tapEvent", this.goodsInfo);
    },
  },

  filters: {
    filterCoupon(val) {
      if (val) {
        let pattern = /\D*([\d+.*\d*]+)\D*([\d+.*\d*]*)\D*/gi;
        if (pattern.test(val)) {
          if (RegExp["$2"]) {
            return RegExp["$2"];
          } else if (RegExp["$1"]) {
            return RegExp["$1"];
          } else {
            return val;
          }
        } else {
          return val;
        }
      } else {
        return val;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.GoodsItem {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 48.8%;
  min-height: vw(273);
  opacity: 1;
  background: #ffffff;
  border-radius: 6px;
  margin-top: vw(10);
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .pic {
    width: 100%;
    height: vw(183.75);
  }
  .bottomPart {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    box-sizing: border-box;
    padding: 4% vw(9) 4%;
    .title {
      font-size: vw(14);
      font-weight: 400;
    }
    .tagBox {
      display: flex;
      align-items: center;
      font-size: vw(11);
      margin: 12px 0 8px;
      .history {
        font-size: vw(13);
        color: #ababab;
        text-decoration: line-through;
        margin-right: vw(5);
      }
      .coupon {
        display: flex;
        align-items: center;
        font-size: vw(12);
        font-weight: 400;
        color: #f23030;
        background-color: #fff1eb;
        height: vw(18);
        padding: 0 vw(4);
        border-radius: vw(3);
      }
    }
    .priceBox {
      color: #f23030;
      .symbol {
        font-size: vw(11);
        font-style: normal;
      }
      .price {
        font-size: vw(20);
        line-height: vw(20);
      }
    }
  }
  &:nth-child(-n + 2) {
    margin-top: 0;
  }
}
</style>